import React, { useState, useEffect } from 'react';
import { View, Text, Switch, TouchableOpacity, StyleSheet } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import ToolTip from './toolTip';

export const PackingCamSetting = ({windowWidth}) => {
  const [isEnabled, setIsEnabled] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const loadStoredValue = async () => {
      try {
        const storedValue = await AsyncStorage.getItem('packingCamEnabled');
        setIsEnabled(storedValue === 'true');
      } catch (error) {
        console.error('Error loading packing cam setting:', error);
      }
    };
    loadStoredValue();
  }, []);

  const toggleSwitch = async (value) => {
    setIsEnabled(value);
    try {
      await AsyncStorage.setItem('packingCamEnabled', value.toString());
    } catch (error) {
      console.error('Error saving packing cam setting:', error);
    }
  };

  return (
    <View style={[
      styles.container,
      windowWidth > 900 ? styles.containerDesktop : styles.containerMobile
    ]}>
      <View style={styles.settingRow}>
        <TouchableOpacity
          style={styles.infoButton}
          onPress={() => setShowTooltip(!showTooltip)}
          testID="tooltipButton"
        >
          <i className="icon-info-circled" style={styles.infoIcon}></i>
        </TouchableOpacity>

        <Switch
          testID="packingCamSwitch"
          value={isEnabled}
          onValueChange={toggleSwitch}
          style={styles.switch}
          offColor="#5c6e79"
          onColor="#5AA6D1"
          offHandleColor="#969696"
          onHandleColor="#fbfdfe"
          handleDiameter={22}
          height={20}
          width={40}
        />

        <Text style={styles.label}>Packing Cam</Text>

        {showTooltip && (
          <ToolTip
            testID="packingCamTooltip"
            message="Enable or disable the Packing Cam feature. When enabled, you can use your camera to scan items during packing."
            windowWidth={windowWidth}
            left="-54%"
            top={15}
            bodyTop={-50}
          />
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    gap: 7,
    zIndex: -1,
    marginTop: 10
  },
  containerDesktop: {
    paddingLeft: 20
  },
  containerMobile: {
    paddingLeft: 10
  },
  settingRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    position: 'relative',
    gap: 15
  },
  infoButton: {
    width: 20,
    opacity: 0.5
  },
  infoIcon: {
    fontSize: 17,
    color: '#ffffff'
  },
  switch: {
    marginRight: 20
  },
  label: {
    color: '#ffffff',
    fontSize: 16,
    fontWeight: '300'
  }
});

export default PackingCamSetting;
